/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { Col, Row, Form } from 'react-bootstrap';

import Layout from '@/components/common/layouts/Layout';
import useForm from '@/lib/hooks/useForm';
import { validateEmail } from '@/lib/util/regex';
import Link from 'next/link';
import interfaceConfig from 'interfaceConfig';
import SignupWithGoogle from '@/components/auth/signup/SignupWithGoogle';
import { useUserContext } from '@/lib/context/useUserContext';
import LineWithText from '@/components/common/LineWithText';
import { signup } from './api/user';
import RealSignupPage from './signuppage/RealSignupPage';

function RealSignUp() {
  const router = useRouter();
  const { orgID, token } = router.query;
  const [message, setMessage] = useState('');
  const { signIn } = useUserContext();
  const [isLoadingIndicator, setIsLoadingIndicator] = useState(false);

  const validate = () => {
    if (!formFields.firstName) {
      setMessage('Please enter your first name.');
      return false;
    }
    if (!formFields.lastName) {
      setMessage('Please enter your last name.');
      return false;
    }
    if (!validateEmail(formFields.email)) {
      setMessage('Please enter a valid email.');
      return false;
    } if (!formFields.password || formFields.password.length < 8) {
      setMessage('Please enter a password that is 8 or more characters.');
      return false;
    }
    return true;
  };

  const onSubmit = () => {
    if (!validate()) {
      return;
    }
    const {
      firstName, lastName, email: caseInsensitiveEmail, password, recaptchaToken,
    } = formFields;
    setIsLoadingIndicator(true);

    const email = caseInsensitiveEmail.toLowerCase();
    const name = `${firstName} ${lastName}`;
    window.analytics.identify(email);

    console.log(formFields);

    signup({
      name, email, password, orgID, token, recaptchaToken,
    })
      .then((res) => {
        console.log(res);
        window.analytics.identify(email, { Name: name, Email: email });
        window.analytics.track('Signup', { Name: name });
        window.location.replace('/welcome');
      })
      .catch((err) => {
        setIsLoadingIndicator(false);
        setMessage(err.message);
      });
  };

  const {
    formFields, handleInputChange, handleSubmit, setFormFields,
  } = useForm(onSubmit);

  return (
    <Layout>
      <Head>
        <title>Big & Mini: Sign Up</title>
        <meta name="description" content="Signing up is easy and free. Fill out your information in sust a few minutes and we will do the rest." />
      </Head>
      <div className="signup">
        <div className="fill-height">
          <Row>
            <Link href="/" className="logo">Big & Mini</Link>
            <Col lg={5} sm={0} className="signup-style">
              <div className="signup-image" style={{ backgroundImage: `url(${interfaceConfig.signupImage})` }} />
            </Col>
            <Col lg={1} className="signup-right" />
            <Col lg={5} sm={12} className="signup-right">

              <Form onSubmit={handleSubmit}>
                <Form.Group className="complete-centered" style={{ marginBottom: '2em', marginTop: '7em' }}>
                  <div>
                    <h1 className="bolded d-inline-block">Create Your Account</h1>
                    <p style={{ margin: '0' }}>
                      {interfaceConfig.signupReasons}
                    </p>
                  </div>
                  <div style={{ color: 'red' }}>{message}</div>
                  <SignupWithGoogle
                    signIn={signIn}
                    setMessage={setMessage}
                    orgID={orgID}
                    orgToken={token}
                  />
                  <LineWithText text="Or" />

                  <RealSignupPage
                    orgID={orgID || ''}
                    token={token || ''}
                    isLoadingIndicator={isLoadingIndicator}
                    setFormFields={setFormFields}
                    handleInputChange={handleInputChange}
                    formFields={formFields}
                  />
                </Form.Group>
              </Form>

              <div className="margin-left">
                <p>
                  By signing up, I agree to
                  {' '}
                  {interfaceConfig.orgName}
                  &apos;s
                  <a href="terms" target="none">&nbsp;Terms of Service&nbsp;&nbsp;</a>
                  and
                  <a href="privacy" target="none">&nbsp;Privacy Policy</a>
                  .
                </p>
                <p className="inline">Already have an account? </p>
                <a className="inline" href="login"> &nbsp;Log In</a>
              </div>
            </Col>
            <Col lg={1} />
          </Row>
        </div>
      </div>
    </Layout>
  );
}

export default RealSignUp;
